import { create } from 'zustand'

type TouchOptimizedStore = {
    isTouchOptimized: boolean
    toggleTouchOptimized: () => void
}

export const useTouchOptimized = create<TouchOptimizedStore>((set) => ({
    isTouchOptimized: false,
    toggleTouchOptimized: () => set((state) => ({ isTouchOptimized: !state.isTouchOptimized })),
}))

